/**
 * TagDetailContainer
 * --
 */
import React from 'react';
import TagDetailPresenter from './TagDetailPresenter';

const TagDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <TagDetailPresenter />
    </>
  );
};

export default TagDetailContainer;
